import React from 'react'
import { StandardsMap } from 'shared/types'
import { NodeIdMap } from '../version_mapping/utility'

type VerifyStandardsData = {
  standardsMap: StandardsMap
  idMap: NodeIdMap
}

export const VerifyStandardsContext = React.createContext<VerifyStandardsData>({
  standardsMap: {},
  idMap: {},
})
